export const socialLinksMessageComponent = {
  key: 'socialLinksMessageComponent',
  name: 'Social Links Message Dept-Component',
  siteIdentifier: 'global',

  followUsLabel: 'Follow us on',
};
